import { HttpInterceptorFn } from '@angular/common/http';
import { isCacheInterceptorContext } from '@web/common';
import { inject } from '@angular/core';
import { HttpCacheResponseService } from '../http/services/http-cache-response.service';
import { isNotNil, shareReplayOnce } from '@web/utils';
import { catchError, throwError } from 'rxjs';

export const CacheInterceptor: HttpInterceptorFn = (request, next) => {
  const httpCacheResponse = inject(HttpCacheResponseService);

  if (isCacheInterceptorContext(request)) {
    const cached$ = httpCacheResponse.getForRequest(request);

    if (isNotNil(cached$)) {
      return cached$;
    }

    const response$ = next(request).pipe(shareReplayOnce());

    httpCacheResponse.setForRequest(request, response$);

    // Błędów nie zapisuje w pamięci podręcznej
    return response$.pipe(
      catchError((error) => {
        httpCacheResponse.clearForRequest(request);

        return throwError(() => error);
      }),
    );
  }

  httpCacheResponse.clearForRequest(request);

  return next(request);
};
